import PropTypes from 'prop-types';


// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Drawer, useMediaQuery, Divider } from '@mui/material';

// project imports
import MenuList from './MenuList';
import LogoSection from '../LogoSection';
import { drawerWidth } from 'store/constant';

const Sidebar = ({ drawerOpen, drawerToggle, window }) => {
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up('md'));

console.log('Drawer selected color =', theme.palette.action.selected);
console.log('Hover color =', theme.palette.action.hover);
console.log('Selected color =', theme.palette.action.selected);

  const container = window !== undefined ? () => window.document.body : undefined;

  const drawer = (
    <>
      {/* Logo visible on mobile */}
      <Box sx={{ display: { xs: 'block', md: 'none' }, p: 2 }}>
        <LogoSection />
      </Box>
      <Divider />
      {/* Menu items */}
      <Box sx={{ px: 2, py: 2 }}>
        <MenuList />
      </Box>
    </>
  );

  return (
    <Box
      component="nav"
      sx={{ flexShrink: { md: 0 }, width: matchUpMd ? drawerWidth : 'auto' }}
      aria-label="sidebar navigation"
    >
      <Drawer
        container={container}
        variant={matchUpMd ? 'permanent' : 'temporary'}
        anchor="left"
        open={drawerOpen}
        onClose={drawerToggle}
        ModalProps={{ keepMounted: true }}
        sx={{
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
        }}
      >
        {/* This ensures proper offset below AppBar */}
        <Box sx={theme.mixins.toolbar} />
        {drawer}
      </Drawer>
    </Box>
  );
};

Sidebar.propTypes = {
  drawerOpen: PropTypes.bool,
  drawerToggle: PropTypes.func,
  window: PropTypes.object,
};

export default Sidebar;

